import addSharedFoldersOperation from 'owa-service/lib/operation/addSharedFoldersOperation';

/**
 * Service to add a shared folder user
 * @param displayName
 * @param primarySMTPAddress
 */
export default function addSharedFoldersService(
    displayName: string,
    primarySMTPAddress: string
): Promise<boolean> {
    return addSharedFoldersOperation({
        displayName: displayName,
        primarySMTPAddress: primarySMTPAddress,
    });
}
